function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { connect } from 'react-redux';

import * as quizzActions from './../quizzActions';
import Aux from './../hoc/_Aux';

var Modal = function (_Component) {
    _inherits(Modal, _Component);

    function Modal() {
        var _temp, _this, _ret;

        _classCallCheck(this, Modal);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.modalButtonHandler = function () {
            var dispatch = _this.props.dispatch;


            dispatch(quizzActions.closeModal(_this.props.relatedToQuizzId));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Modal.prototype.render = function render() {

        //const { showResult, currentAnswerIsValid, correctAnswers } = this.props;
        var currentQuizzId = typeof this.props.relatedToQuizzId !== 'undefined' ? this.props.relatedToQuizzId : '';

        var modalTitle = 'Perdu';
        var modalDescContent = '';
        var currentAnswerIsValid = false;
        var correctAnswers = [];
        var showResult = false;
        var isLastStep = false;

        if (Object.keys(this.props.quizzList).length > 0) {
            if (currentQuizzId !== '' && this.props.quizzList.hasOwnProperty(currentQuizzId) && Object.keys(this.props.quizzList[currentQuizzId]).length > 0) {
                var quizzData = this.props.quizzList[currentQuizzId];
                if (quizzData.hasOwnProperty('quizzAnswerIsValid')) {
                    currentAnswerIsValid = quizzData.quizzAnswerIsValid;
                }
                currentAnswerIsValid = quizzData.hasOwnProperty('quizzAnswerIsValid') ? quizzData.quizzAnswerIsValid : false;
                if (quizzData.hasOwnProperty('quizzGoodAnswers')) {
                    correctAnswers = quizzData.quizzGoodAnswers;
                }
                if (quizzData.hasOwnProperty('showResult')) {
                    showResult = quizzData.showResult;
                }
                isLastStep = quizzData.totalQuizzStep - (quizzData.quizzStep + 1) === 0 ? true : false;
            }
        }

        if (!currentAnswerIsValid && correctAnswers.length === 0) {

            modalTitle = 'Pas si vite';
            modalDescContent = 'Choisis au moins une réponse avant de valider';
        } else if (currentAnswerIsValid) {

            modalTitle = 'Bravo';
            if (!isLastStep) {
                modalDescContent = 'C\'était la bonne réponse';
            } else {
                if (this.props.isUnlockingArticle) {
                    modalDescContent = 'tu as débloqué la suite de l\'article';
                } else {
                    modalDescContent = 'tu as gagné 20 points';
                }
            }
        } else {

            modalTitle = 'Perdu';
            modalDescContent = 'la réponse était : ' + correctAnswers.join(', ');
            if (isLastStep && this.props.isUnlockingArticle) {
                modalDescContent += '\n mais tu peux accéder à la suite de l\'article';
            }
        }

        var modalContainer = React.createElement(
            'div',
            { className: 'modal-container' },
            React.createElement(
                'span',
                { className: (currentAnswerIsValid === true ? 'win' : 'loose') + '-icon' },
                '\xA0'
            ),
            React.createElement(
                'h4',
                null,
                modalTitle
            ),
            React.createElement(
                'p',
                null,
                modalDescContent
            ),
            React.createElement('span', { className: 'btn-close', onClick: this.modalButtonHandler })
        );

        return React.createElement(
            Aux,
            null,
            showResult ? React.createElement('div', { className: 'modal-backdrop', onClick: this.modalButtonHandler }) : null,
            React.createElement(
                'div',
                {
                    className: 'modal-panel-quizz',
                    style: {
                        transform: showResult ? 'translateY(0)' : 'translateY(-2000px)',
                        opacity: showResult ? '1' : '0'
                    } },
                modalContainer
            )
        );
    };

    return Modal;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
    return {
        quizzList: state.quizz.articleQuizzes
    };
};

export default connect(mapStateToProps)(Modal);


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-quiz/es/components/Quizz/Modal/Modal.js
// module id = 233
// module chunks = 0